import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import React, { useContext } from 'react';
import { HeaderContext } from '../../shared';
import { MenuListContainer, MultiMenuContainer, MenuTitle, MenuDivider } from '../../styles/multiMenu';
import { MenuItemsList } from './';

var MultiMenu = function MultiMenu(_ref) {
  var multiMenuIndex = _ref.multiMenuIndex,
      menuItems = _ref.menuItems,
      activeItem = _ref.activeItem,
      breadcrumbs = _ref.breadcrumbs,
      isMobile = _ref.isMobile;

  var _useContext = useContext(HeaderContext),
      dataTestPrefix = _useContext.dataTestPrefix;

  return /*#__PURE__*/React.createElement(MultiMenuContainer, {
    "data-test": "".concat(dataTestPrefix, "-multi-menu-container-").concat(multiMenuIndex)
  }, menuItems.map(function (_ref2, index) {
    var parent = _ref2.parent,
        children = _ref2.children;
    var _ref3 = parent,
        menuTitle = _ref3.text;

    var MenuListWithBorder = function MenuListWithBorder() {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(MenuListContainer, {
        key: index,
        "data-test": "".concat(dataTestPrefix, "-multi-menu-list-container-").concat(index)
      }, /*#__PURE__*/React.createElement(MenuTitle, {
        key: "title-".concat(index),
        "data-test": "".concat(dataTestPrefix, "-multi-menu-list-").concat(index, "-title")
      }, menuTitle), /*#__PURE__*/React.createElement(MenuItemsList, {
        listIndex: index,
        itemsList: children,
        activeItem: activeItem,
        key: "menu-list-".concat(index),
        breadcrumbs: breadcrumbs ? [].concat(_toConsumableArray(breadcrumbs), [menuTitle]) : [menuTitle],
        isMobile: isMobile
      })), index < menuItems.length - 1 && /*#__PURE__*/React.createElement(MenuDivider, {
        key: "divider-".concat(index),
        "data-test": "".concat(dataTestPrefix, "-multi-menu-list-").concat(index, "-divider")
      }));
    };

    return /*#__PURE__*/React.createElement(MenuListWithBorder, {
      key: index
    });
  }));
};

MultiMenu.displayName = 'MultiMenu';
export default MultiMenu;